// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6d1310bb","453":"85157173","455":"ee217c7d","977":"5ef35b7a"}[chunkId] + ".chunk.js";
};